import { useEffect } from "react";
import { motion } from "framer-motion";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | DUSA` : "DUSA – Ideias que fazem marca";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = description || "Vinis, murais, acrílicos, t-shirts e comunicação visual personalizada. Pede o teu orçamento por WhatsApp.";
  }, [title, description]);
}

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.2, 0.7, 0.2, 1] }}>
    {children}
  </motion.div>
);

export const Container = ({ children, className = "" }) => <div className={`mx-auto w-full max-w-7xl px-5 sm:px-8 ${className}`}>{children}</div>;
